import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs';

@Injectable()
export class RouterProjectService {
  projectId = new BehaviorSubject<string>("");

  constructor() { }
 
  // method này để change source message 
  setData(projectId) {
    this.projectId.next(projectId);
  }
  getData()
  {
      return this.projectId.asObservable();;
  }
  
}


// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/_services/router-project.service.ts